import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import api from "@/lib/api";
import { Bell, Heart, MessageCircle, UserPlus } from "lucide-react";

const typeMeta = {
  like: { icon: Heart, color: "text-[#00E676]", verb: "liked your post" },
  comment: { icon: MessageCircle, color: "text-[#F4E8C1]", verb: "commented on your post" },
  follow: { icon: UserPlus, color: "text-[#00E676]", verb: "started following you" },
};

export default function Notifications() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/notifications").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <Layout>
      <div className="max-w-3xl mx-auto py-8 px-4 md:px-8">
        <h1 className="font-heading font-bold text-4xl tracking-tight mb-6">Notifications</h1>

        {loading ? (
          <div className="space-y-2">{[1, 2, 3].map((i) => <div key={i} className="surface rounded-md h-16 shimmer" />)}</div>
        ) : items.length === 0 ? (
          <div className="surface rounded-xl p-12 text-center">
            <Bell size={32} className="text-[#00E676] mx-auto mb-3" strokeWidth={1.5} />
            <div className="font-heading font-bold text-xl mb-1">All caught up.</div>
            <div className="text-sm text-white/50">Drop a post to spark engagement.</div>
          </div>
        ) : (
          <div className="surface rounded-xl overflow-hidden">
            {items.map((n) => {
              const meta = typeMeta[n.type] || typeMeta.like;
              return (
                <div
                  key={n.notif_id}
                  data-testid={`notif-${n.notif_id}`}
                  className="px-4 py-3 flex items-center gap-3 border-b border-white/5 last:border-0 hover:bg-white/[0.02] transition-colors"
                >
                  <div className={`w-8 h-8 rounded-md surface-elev flex items-center justify-center ${meta.color}`}>
                    <meta.icon size={14} fill="currentColor" strokeWidth={2} />
                  </div>
                  <img
                    src={n.actor?.picture || `https://api.dicebear.com/9.x/notionists/svg?seed=${n.actor?.user_id}`}
                    alt=""
                    className="w-9 h-9 rounded-md object-cover bg-white/5"
                  />
                  <div className="flex-1 min-w-0">
                    <div className="text-sm">
                      <span className="font-semibold">{n.actor?.name || "Someone"}</span>{" "}
                      <span className="text-white/60">{meta.verb}</span>
                    </div>
                    <div className="text-[11px] text-white/40 font-mono">{new Date(n.created_at).toLocaleString()}</div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </Layout>
  );
}
